import { doApi } from './apiClient';
import type { Expansion } from '../types/models/expansion';

export const apiGetExpansions = (): Promise<Expansion[]> =>
  doApi<Expansion[]>('api/expansions', 'GET');

export const apiGetExpansion = (id: number): Promise<Expansion> =>
  doApi<Expansion>(`api/expansions/${id}`, 'GET');

export const apiCreateExpansion = (data: FormData): Promise<Expansion> =>
  doApi<Expansion>('api/expansions', 'POST', data, true);

export const apiUpdateExpansion = (id: number, data: FormData): Promise<Expansion> =>
  doApi<Expansion>(`api/expansions/${id}`, 'POST', data, true);

export const apiDeleteExpansion = (id: number): Promise<{ message: string }> =>
  doApi(`api/expansions/${id}`, 'DELETE');

export const apiAttachCard = (
  expansionId: number,
  cardId: number,
  dropRate: number
): Promise<{ success: boolean }> =>
  doApi('api/expansions/' + expansionId + '/cards', 'POST', { card_id: cardId, drop_rate: dropRate });

export const apiDetachCard = (
  expansionId: number,
  cardId: number
): Promise<{ success: boolean }> =>
  doApi(`api/expansions/${expansionId}/cards/${cardId}`, 'DELETE');

export const apiUpdateCardDropRate = (
  expansionId: number,
  cardId: number,
  dropRate: number
): Promise<{ success: boolean }> =>
  doApi(`api/expansions/${expansionId}/cards/${cardId}`, 'PATCH', { drop_rate: dropRate });
